module.exports = __webpack_public_path__ + "5c114213/img/share-icon.0f8a11b4.svg";